import { create } from 'zustand'

interface PositiveFeedbackState {
  isVisible: boolean
  message?: string
  trigger: (message: string) => void
  clear: () => void
}

export const usePositiveFeedbackStore = create<PositiveFeedbackState>(set => ({
  isVisible: false,
  message: undefined,

  trigger: (message) => {
    set({ isVisible: true, message })
  },

  clear: () => {
    set({ isVisible: false, message: undefined })
  },
}))
